module.exports = __webpack_public_path__ + "img/icraprooldicon.7a226c4c.svg";